import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminLeads.css";

function AdminBuys() {
  const navigate = useNavigate();

  return (
    <div className="main-layout">

      <div className="sidebar">
        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
          <li onClick={() => navigate("/admin/properties")}>Properties</li>
          <li className="active">Buys</li>
          <li onClick={() => navigate("/admin/Sales")}>Sales</li>
          <li onClick={() => navigate("/admin/Rents")}>Rents</li>
          <li onClick={() => navigate("/admin/messages")}>Messages</li>
          <li onClick={() => navigate("/admin/settings")}>Settings</li>
        </ul>
      </div>

      <div className="dashboard-container">
        <div className="topbar">
          🔍 Leads Page
        </div>

        <h2>Leads</h2>
        <p>No leads yet</p>
      </div>

    </div>
  );
}

export default AdminBuys;